function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { Typography } from '@material-ui/core';
export var SingleValue = function SingleValue(_ref) {
  var selectProps = _ref.selectProps,
      innerProps = _ref.innerProps,
      children = _ref.children;

  var style = _objectSpread({
    width: '100%'
  }, selectProps.isDisabled ? {
    color: 'rgb(180, 180, 180)'
  } : {});

  return /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1",
    component: "p",
    color: "textSecondary",
    style: style,
    className: selectProps.childrenClasses.placeholder
  }, children);
};